const vercelRuntimeEnv: string | undefined = process.env.NEXT_PUBLIC_VERCEL_ENV;
const nodeRuntimeEnv: string | undefined = process.env.NODE_ENV;

export const isRuntimeTest: boolean = nodeRuntimeEnv === 'test';
export const isRuntimeStaging: boolean = vercelRuntimeEnv === 'preview';
export const isRuntimeProduction: boolean = vercelRuntimeEnv === 'production';
export const isRuntimeDevelopment: boolean =
  !isRuntimeStaging && !isRuntimeProduction && !isRuntimeTest;
